import { createAction } from '@reduxjs/toolkit';
import { RequestError, Callback } from 'types';
import { State } from './types';

export const fetchMasks = createAction('masks/fetch', (callback?: Callback<unknown, void>) => ({
  payload: undefined,
  meta: { callback },
}));

export const fetchedMasks = createAction('masks/fetched', (data?: State['data'], error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export const fetchMask = createAction('mask/fetch', (situationId: string, callback?: Callback<unknown, void>) => ({
  payload: undefined,
  meta: { situationId, callback },
}));

export const fetchedMask = createAction('mask/fetched', (data?: State['selectedMask'], error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export default {
  fetchedMasks,
  fetchMasks,
  fetchMask,
  fetchedMask,
};
